import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AppComponent } from "./app.component";
import { HomeComponent } from "./home/home.component";
import { WelcomeComponent } from "./welcome/welcome.component";
import { DetailsComponent } from "./details/details.component";
import { ThankyouComponent } from "./thankyou/thankyou.component";
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { BillingComponent } from "./billing/billing.component";
import { PaymentComponent } from "./payment/payment.component";
import { SuccessComponent } from "./success/success.component";


const routes: Routes = [
    {
        path: '', component: HomeComponent,
        children: [
            
            {
                path: 'thankyou', component: ThankyouComponent
            },
            {
                path: 'details', component: DetailsComponent
            },
            {
                path: 'billing', component: BillingComponent
            },
            {
                path: 'payment/:formId/:postCode', component: PaymentComponent
            },            
            {
                path: 'success', component: SuccessComponent
            },
            {
                path: ':id', component: WelcomeComponent 
            },
        ]
    },
    //Wild Card Route for 404 request 
    { 
         path: '**', pathMatch: 'full', component: PagenotfoundComponent 
    },         
]

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
    
}